import React, { useEffect, useState } from "react";
import ParametersDetails from "./Descriptions/OthersSoloParameters/Index";
import HealthParametersDetails from "./Descriptions/healthSoloParameters/Index";
import { useTranslation } from '../../hooks/useTranslation';
import {useSelector } from 'react-redux';

const ReportParameterDescriptions = ({dish}) => {
  const [array, setArray] = useState([]);
  const { t } = useTranslation();
  const categoryAverages = useSelector(state => state.categories.categoryAverages);

  const getCategoryAverage = (parameterName) => {
    
    if (!categoryAverages) {
      console.log('❌ No categoryAverages available, returning 0');
      return 0; // Fallback to 0 if no category averages available
    }

    // Map Swedish parameter names to English field names
    const parameterMapping = {
      "Klimat": "climate_score",
      "Vatten": "water_score", 
      "Biologisk mångfald": "biodiversity_score",
      "Transport": "transport_score",
      "Landanvändning": "land_use_score",
      "Övergödning": "fertilizers_use_score",
      "Bekämpningsmedel": "pesticides_use_score",
      "Hälsa": "health_score",
      "Antibiotikaresistens": "antibiotics_resistance_score",
      "Social rättvisa": "social_justice_score",
      "Barnarbete": "child_labor_score",
      "Djurvälfärd": "animal_protection_score",
      "Arbetsförhållanden": "worker_rights_score",
      "Jämlikhet": "equality_score",
      "Lokalbefolkning": "local_population_score"
    };

    const fieldName = parameterMapping[parameterName];
    const averageKey = fieldName + '_category_average';
    console.log('🔍 Looking for field:', fieldName, 'averageKey:', averageKey);
    
    if (fieldName && categoryAverages[averageKey] !== undefined) {
      const average = categoryAverages[averageKey] || 0;
      console.log('✅ Found average for', parameterName, ':', average);
      return average;
    }
    
    console.log('❌ Field not found, returning 0');
    return 0; // Fallback if field not found
  };

  useEffect(() => {
    if (dish) {
      const convertedParameters = {
        "Klimat": { value: dish.climate_score || 0 , imgFile:'', bonus:null},
        "Vatten": { value: dish.water_score || 0 },
        "Biologisk mångfald": { value: dish.biodiversity_score || 0 , imgFile:'', bonus:null},
        "Transport": { value: dish.transport_score || 0 , imgFile:'', bonus:null},
        "Landanvändning": { value: dish.land_use_score || 0 , imgFile:'', bonus:null},
        "Övergödning": { value: dish.fertilizers_use_score || 0 , imgFile:'', bonus:null},
        "Bekämpningsmedel": { value: dish.pesticides_use_score || 0 , imgFile:'', bonus:null},
        "Hälsa": { value: dish.health_score || 0 , imgFile:'', bonus:null},
        "Antibiotikaresistens": { value: dish.antibiotics_resistance_score || 0 , imgFile:'', bonus:null},
        "Social rättvisa": { value: dish.social_justice_score || 0 , imgFile:'', bonus:null},
        "Barnarbete": { value: dish.child_labor_score || 0 , imgFile:'', bonus:null},
        "Djurvälfärd": { value: dish.animal_protection_score || 0 , imgFile:'', bonus:null},
        "Arbetsförhållanden": { value: dish.worker_rights_score || 0 , imgFile:'', bonus:null},
        "Jämlikhet": { value: dish.equality_score || 0 , imgFile:'', bonus:null},
        "Lokalbefolkning": { value: dish.local_population_score || 0 , imgFile:'', bonus:null}
      };
      setArray(Object.entries(convertedParameters));
    }
  }, [dish]);

  const PAGE_HEIGHT = 1122; 
  let currentHeight = 0;

  return (
    <div className="flex flex-col w-full pt-5 break-inside-avoid">
      {array.map(([key, parameterData], index) => {
        const parameterHeight = PAGE_HEIGHT / 3; 
        const shouldBreak = currentHeight + parameterHeight > PAGE_HEIGHT;

        if (shouldBreak) {
          currentHeight = 0; // Reset for new page
        }
        currentHeight += parameterHeight;

        // Create a data object with the structure expected by the components
        const categoryAverage = getCategoryAverage(key);
        const data = {
          name: key, // Use the Swedish parameter name directly
          score: parameterData.value,
          bonus: parameterData.bonus,
          categories: [
            { name: "Rättens värde", score: parameterData.value },
            { name: "Genomsnitt värde för rättens kategori", score: categoryAverage },
            // { name: "Genomsnitt för alla produkter", score: parameterData.value }
          ],
          waterScores: parameterData.waterScores || {},
          waterInM3PerTon: dish.water_in_m3ton || {}
        };

        return (
          <div
            key={index}
            className={`w-full p-2 mt-3 break-inside-avoid ${shouldBreak ? 'break-inside-avoid' : ''}`}
          >
            {key === "Hälsa" ? (
              <HealthParametersDetails data={data} classesTwo="px-3" t={t} />
            ) : key === "Klimat" || key === "Transport" ? (
              <ParametersDetails data={data} classesTwo="py-0 px-3" t={t} />
            ) : key === "Vatten" ? (
              <ParametersDetails data={data} classesTwo="py-0 px-3 " t={t} />
            ) : (
              <ParametersDetails data={data} classesTwo="py-0 px-3" t={t} />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ReportParameterDescriptions;
